import { Injectable } from '@angular/core';
import { defaultIfEmpty, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppStateService } from './app-state.service';
import { ApiEndpointService } from './core/services/api-endpoint.service';
import { EnvironmentService } from './core/services/environment.service';
import { UniversalLoginService } from './login/services/universal-login.service';

@Injectable()
export class PreLoadService {

    public constructor(private readonly environmentService: EnvironmentService,
                       private readonly apiEndpointService: ApiEndpointService,
                       private readonly appStateService: AppStateService,
                       private readonly universalLoginService: UniversalLoginService,
    ) {
    }

    public load(): Promise<unknown> {
        return new Promise((resolve, reject) => {
            this.environmentService.getEnvironmentFile()
                .pipe(
                    catchError(
                        (err) => {
                            console.error(err);
                            reject(err);
                            return of(null);
                        },
                    ),
                    switchMap(
                        (env) => {
                            if (env) {
                                this.apiEndpointService.constructEndpoints();
                            }

                            const hasSession$ = this.universalLoginService.isAuth0Enabled()
                                ? from(this.universalLoginService.isAuthenticated())
                                : of(false);

                            return hasSession$.pipe(
                                switchMap((hasSession) => hasSession
                                    ? this.appStateService.refreshAppState().pipe(
                                        defaultIfEmpty(true),
                                        map((appState) => !!appState),
                                        catchError((error) => {
                                            console.warn('[PreLoadService] Unable to restore the saved session during startup:', error);
                                            return of(true);
                                        }),
                                    )
                                    : of(true),
                                ),
                            );
                        },
                    ),
                )
                .subscribe({
                    next: () => resolve(true),
                    error: (error) => reject(error),
                });
        });
    }
}
